import {createGate} from 'effector-react';

export const ViewManufacturerGate = createGate()